/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./ForumAttachmentItem.vue?vue&type=template&id=c958e3ae&scoped=true"
import script from "./ForumAttachmentItem.vue?vue&type=script&setup=true&lang=js"
export * from "./ForumAttachmentItem.vue?vue&type=script&setup=true&lang=js"
import style0 from "./ForumAttachmentItem.vue?vue&type=style&index=0&id=c958e3ae&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c958e3ae",
  null
  
)

export default component.exports